// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportAlarmRequest
 */
export interface ReportAlarmRequest {
    /**
     * Human-readable comment recorded with the report event
     */
    comment?: string;
}

/**
 * Check if a given object implements the ReportAlarmRequest interface.
 */
export function instanceOfReportAlarmRequest(value: object): value is ReportAlarmRequest {
    return true;
}

export function ReportAlarmRequestFromJSON(json: any): ReportAlarmRequest {
    return ReportAlarmRequestFromJSONTyped(json, false);
}

export function ReportAlarmRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportAlarmRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function ReportAlarmRequestToJSON(json: any): ReportAlarmRequest {
    return ReportAlarmRequestToJSONTyped(json, false);
}

export function ReportAlarmRequestToJSONTyped(value?: ReportAlarmRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
    };
}

